import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';
import { Button, Checkbox, Form, Input, Select } from 'antd';
import React from 'react';

export type StatusNewsFormProps = {
  form: any;
  loading: boolean;
  onSubmit: (values: any) => void;
};

const StatusNewsForm: React.FC<StatusNewsFormProps> = ({
  form,
  loading,
  onSubmit,
}) => (
  <Form
    form={form}
    layout="vertical"
    onFinish={onSubmit}
    initialValues={{
      type: 'info',
      title: '',
      text: '',
      enabled: false,
      leftAlign: false,
      priority: 1,
      linkText: '',
      linkUrl: '',
    }}
  >
    <Form.Item name="type" label="Type" rules={[{ required: true }]}>
      <Select>
        <Select.Option value="info" icon={<InfoCircleOutlined />}>
          Info
        </Select.Option>
        <Select.Option value="success" icon={<CheckCircleOutlined />}>
          Success
        </Select.Option>
        <Select.Option value="error" icon={<CloseCircleOutlined />}>
          Error
        </Select.Option>
      </Select>
    </Form.Item>
    <Form.Item name="title" label="Title (only used for support dashboard)">
      <Input placeholder="Optional short title " maxLength={80} />
    </Form.Item>
    <Form.Item name="text" label="Text">
      <Input.TextArea
        placeholder="Status message"
        maxLength={220}
        rows={3}
        showCount
      />
    </Form.Item>
    <Form.Item name="enabled" valuePropName="checked">
      <Checkbox>Enabled (show on portal)</Checkbox>
    </Form.Item>
    <Form.Item name="leftAlign" valuePropName="checked">
      <Checkbox>Left Align (left align content)</Checkbox>
    </Form.Item>
    <Form.Item
      name="priority"
      label="Priority (if more, list after priority)"
      rules={[{ required: true }]}
    >
      <Input type="number" min={1} max={10} style={{ width: 120 }} />
    </Form.Item>
    <Form.Item name="linkText" label="Link Text">
      <Input placeholder="Optional link text (Read more)" maxLength={40} />
    </Form.Item>
    <Form.Item name="linkUrl" label="Link URL">
      <Input
        placeholder="Optional link URL (https://vibrant.io)"
        maxLength={120}
      />
    </Form.Item>
    <Form.Item>
      <Button type="primary" htmlType="submit" loading={loading} block>
        Create
      </Button>
    </Form.Item>
  </Form>
);

export default StatusNewsForm;
